
import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
} from '@react-pdf/renderer';
import { Slab } from '@/types/slab';

const styles = StyleSheet.create({
  viewer: {
    width: '100%',
    height: '100%',
  },
  page: {
    backgroundColor: 'white',
    padding: 5,
  },
  mainContainer: {
    flexDirection: 'row',
    height: '100%',
  },
  logoContainer: {
    width: '20%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
  },
  logo: {
    height: '100%',
    objectFit: 'contain',
    transform: 'rotate(-90deg)',
  },
  contentContainer: {
    width: '80%',
    padding: '2px 5px',
    height: '100%',
    justifyContent: 'space-between',
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: '10px',
  },
  titleContainer: {
    alignItems: 'center',
  },
  bottomRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: '10px',
  },
  title: {
    fontSize: 14,
    textTransform: 'uppercase',
  },
  text: {
    fontSize: 8,
    color: '#737373',
    textTransform: 'uppercase',
  },
});

interface SlabLabelProps {
  slab: Slab;
}

export function SlabLabel({ slab }: SlabLabelProps) {
  return (
    <PDFViewer style={styles.viewer}>
      <Document>
        <Page size={[288, 72]} style={styles.page}>
          <View style={styles.mainContainer}>
            <View style={styles.logoContainer}>
              <Image 
                src="/hivehub-uploads/MAX LOGO.png"
                style={styles.logo}
              />
            </View>
            
            <View style={styles.contentContainer}>
              <View style={styles.topRow}>
                <Text style={styles.text}>
                  {slab.dimensions ? `${slab.dimensions.length}x${slab.dimensions.height}` : ''}
                </Text>
                <Text style={styles.text}>{slab.type}</Text>
              </View>

              <View style={styles.titleContainer}>
                <Text style={styles.title}>{slab.name}</Text>
              </View>

              <View style={styles.bottomRow}>
                <Text style={styles.text}>
                  {slab.sqft ? `SQFT: ${slab.sqft}` : ''}
                </Text>
                <Text style={styles.text}>{slab.code}</Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
}
